import React from 'react';

interface ICustomNodeDesignProps {
    children?: React.ReactNode[];
    bgColor: string | unknown;
    borderColor: string | unknown;
}

export const CustomNodeDesign: React.FC<ICustomNodeDesignProps> = ({ children, bgColor, borderColor }) => {
    return (
        <div
            style={{
                width: '240px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                padding: '1rem',
                gap: '1rem',
                backgroundColor: bgColor as string,
                color: 'black',
                border: `2px solid ${borderColor as string}`,
                fontWeight: '700',
                borderRadius: '1rem',
                boxShadow: '0 .2rem .5rem rgba(0,0,0,.15)',
                cursor: 'pointer',
                outline: `5px solid rgba(0,0,0,.08)`,
                outlineOffset: '2px',
            }}
        >
            {children}
        </div>
    );
};
